import React from "react";

export function Button({ children, onClick, type = "button", variant = "solid", size = "md", className = "", ...props }) {
  const base = "rounded-lg font-medium transition duration-200 inline-flex items-center justify-center";
  const sizes = {
    sm: "px-4 py-1.5 text-sm",
    md: "px-5 py-2 text-base",
    lg: "px-8 py-3 text-lg",
  };
  const styles = {
    solid: "bg-gray-300 hover:bg-gray-200 text-gray-900",
    outline: "border border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900",
    "outline-white": "border border-white text-white hover:bg-white hover:text-gray-900",
    ghost: "text-gray-500 hover:text-gray-900 hover:bg-gray-100",
  };

  return (
    <button
      onClick={onClick}
      type={type}
      className={`${base} ${sizes[size] || sizes.md} ${styles[variant] || styles.solid} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
